import { Card, Input, Row, Col, Button, notification } from "antd";
import { useRef } from "react";
import { backendURL } from "../Globals";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"; // ✅ Para manejar cookies seguras

import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Checkbox, Form } from "antd";

const LoginUserComponent = ({ setLogin }) => {
  const navigate = useNavigate();
  const email = useRef(null);
  const password = useRef(null);

  const onFinish = (values) => {
    console.log("📌 Datos enviados al backend: ", values);
    clickLogin(values);
  };

  const clickLogin = async (values) => {
    try {
      let response = await fetch(`${backendURL}/users/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: values.username,
          password: values.password,
        }),
      });

      if (response.ok) {
        let jsonData = await response.json();

        if (jsonData.apiKey) {
          console.log("🔑 API Key recibida:", jsonData.apiKey);

          // ✅ Guardar API Key en LocalStorage y Cookies
          localStorage.setItem("apiKey", jsonData.apiKey);
          Cookies.set("apiKey", jsonData.apiKey, { expires: 1, secure: true });

          setLogin(true);
          navigate("/dashboards");
        } else {
          throw new Error("No API Key received");
        }
      } else {
        let errorData = await response.json();
        notification.error({
          message: "Error de inicio de sesión",
          description: errorData.error || "Credenciales incorrectas",
        });
      }
    } catch (error) {
      console.error("⛔ Error en el login:", error);
      notification.error({
        message: "Error de conexión",
        description: "No se pudo conectar con el servidor. Inténtalo más tarde.",
      });
    }
  };

  return (
    <Row className="cajas-centradas">
      <Col>
        <Card
          style={{
            width: "350px",
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
            borderRadius: "10px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <Form name="login-form" initialValues={{ remember: true }} onFinish={onFinish}>
            <Form.Item name="username" rules={[{ required: true, message: "Introduce tu usuario" }]}>
              <Input ref={email} prefix={<UserOutlined />} placeholder="Usuario" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: "Introduce tu contraseña" }]}>
              <Input ref={password} prefix={<LockOutlined />} type="password" placeholder="Contraseña" />
            </Form.Item>
            <Form.Item>
              <Checkbox>Recordarme</Checkbox>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">Iniciar sesión</Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default LoginUserComponent;

